import consIcon1 from '@/assets/landing/proscons/cons-1.webp'
import consIcon2 from '@/assets/landing/proscons/cons-2.webp'
import headerIconCons from '@/assets/landing/proscons/icon-cons.svg'
import headerIconPros from '@/assets/landing/proscons/icon-pros.svg'
import prosIcon1 from '@/assets/landing/proscons/pros-1.webp'
import prosIcon2 from '@/assets/landing/proscons/pros-2.webp'
import prosIcon3 from '@/assets/landing/proscons/pros-3.webp'

import { ProsConsCard } from './ProsConsCard'
import {
  CardList,
  GroupHeader,
  GroupHeaderIcon,
  GroupHeaderText,
  ProsConsContainer,
  ProsConsGroup,
} from './styles'

const CONS_ITEMS = [
  { icon: consIcon1, tag: '과적 시 지퍼 열림', descLines: ['너무 많이 담으면', '지퍼백이 열릴 수 있어요'] },
  { icon: consIcon2, tag: '끝부분 날카로움', descLines: ['비닐 끝부분을 가위로', '둥글게 잘라 사용해주세요'] },
]

const PROS_ITEMS = [
  { icon: prosIcon1, tag: '냄새 차단 UP', descLines: ['상단 지퍼백 구조로', '밀봉력을 더 강화했어요'] },
  { icon: prosIcon2, tag: '넉넉한 사이즈', descLines: ['60㎝ * 75㎝ * 8㎝', '냉장고 청소도 거뜬히!'] },
  { icon: prosIcon3, tag: '튼튼한 재질', descLines: ['수분 많은 음식물을 담아도', '찢어지거나 새지 않아요'] },
]

export function ProsConsSection() {
  return (
    <ProsConsContainer>
      <ProsConsGroup>
        <GroupHeader>
          <GroupHeaderIcon
            src={headerIconCons}
            alt=''
          />
          <GroupHeaderText tone='cons'>이런 문제점이 있어요</GroupHeaderText>
        </GroupHeader>
        <CardList>
          {CONS_ITEMS.map((item) => (
            <ProsConsCard
              key={item.tag}
              tone='cons'
              icon={item.icon}
              tag={item.tag}
              descLines={item.descLines}
            />
          ))}
        </CardList>
      </ProsConsGroup>

      <ProsConsGroup>
        <GroupHeader>
          <GroupHeaderIcon
            src={headerIconPros}
            alt=''
          />
          <GroupHeaderText tone='pros'>이런 점은 좋아요</GroupHeaderText>
        </GroupHeader>
        <CardList>
          {PROS_ITEMS.map((item) => (
            <ProsConsCard
              key={item.tag}
              tone='pros'
              icon={item.icon}
              tag={item.tag}
              descLines={item.descLines}
            />
          ))}
        </CardList>
      </ProsConsGroup>
    </ProsConsContainer>
  )
}
